export default __webpack_public_path__ + "static/premioParticipa-18a5f82160c461cb2bd75a46ed6bd970.png";